// export const GET_ALL_REVENUE_PLAN_TEAMSALE = `
// query GetAllTeamSaleRoute(
//   $input: TteamSalesRouteWhereInput
//   $skip: Float
//   $take: Float
// ) {
//   getTeamSalesRoute(where: $input, skip: $skip, take: $take, orderBy:{createDate: DESC}) {
//     pageInfo {
//       currentPage
//       hasNextPage
//       hasPreviousPage
//       itemsPerPage
//       totalItems
//       totalPages
//     }
//     items {
//       id
//       troute{
//         id
//         name
//         plantId
//         trouteAreas{
//             tcity{
//                 name
//             }
//             tdistrict{
//                 name
//             }
//             tward{
//                 name
//             }
//         }
//       }
//       teamSalesId
//       tteamSales {
//         id
//         name
//         isWork
//         plantId
//         salesTeamCode
//         tteamType {
//           id
//           name
//         }
//       }
//       useYn
//       createDate
//       modifyDate
//       ttrip{
//         id
//         name
//       }
//       tcreateUser{
//         fullName
//       }
//       tmodifyUser{
//         fullName
//       }
//     }
//   }
// }

// `;

export const GET_ALL_SALE_TEAM_ROUTE_TRIP = `
  query GetAllTeamSaleRouteTrip($input: FteamRouteTripInput, $skip: Float, $take: Float){
    getFteamRouteTrip(where: $input, skip: $skip, take: $take){
      pageInfo{
          currentPage
          hasNextPage
          hasPreviousPage
          itemsPerPage
          totalItems
          totalPages
      }
      items{
          id
          teamSaleId
          teamId
          teamSaleName
          routeId
          plantId
          routeName
          tripId
          tripName
          expectedRevenue
          actualRevenue
          unitPrice
          useYn
          createDate
          modifyDate
          createName
          modifyName
      }
    }
  }
`;

export const Update_team_sales_route = `mutation UpdateTeamSaleRoute($data: TteamSalesRouteInput!) {
  updateTeamSalesRoute(input: $data) {
    id
    teamSalesId
    routeId
    useYn
    tripId
  }
}

`;

export const CHECK_EXIST_SALE_TEAM_IN_ROUTE = `
  query GetAllTeamSaleRoute(
    $input: TteamSalesRouteWhereInput
    $skip: Float
    $take: Float
  ) {
    getTeamSalesRoute(where: $input, skip: $skip, take: $take, orderBy:{createDate: DESC}) {
      pageInfo {
        currentPage
        hasNextPage
        hasPreviousPage
        itemsPerPage
        totalItems
        totalPages
      }
      items {
        id
        troute{
          id
          name
          plantId
          trouteAreas{
              tcity{
                  name
              }
              tdistrict{
                  name
              }
              tward{
                  name
              }
          }
        }
        teamSalesId
        tteamSales {
          subId
          id
          name
          isWork
          plantId
          salesTeamCode
          tteamType {
            id
            name
          }
        }
        useYn
        createDate
        modifyDate
        ttrip{
          id
          name
        }
        tcreateUser{
          fullName
        }
        tmodifyUser{
          fullName
        }
      }
    }
  }
`;

export const CREATE_SALE_TEAM_ROUTE = `
  mutation CreateTeamSaleDetail($data: TteamSalesRouteInput!) {
    createTeamSalesRoute(input: $data) {
      id
      teamSalesId
      routeId
    }
  }
`;

export const CHECK_EXIST_SALE_TEAM_ROUTE = `
  query CheckExistedTeamsaleRoute($input:TteamSalesRouteWhereInput!){
    getTeamSalesRoute(where:$input){
        items{
            id
            routeId
            teamSalesId
        }
    }
  }
`;

export const UPDATE_MANY_SALES_TEAM_ROUTE = `
  mutation CreateMany($input: [TteamSalesRouteInput!]!){
    updateManyTeamSalesRoute(input: $input){
      teamSalesId
      routeId
      useYn
    }
  }
`;

export const GET_ALL_TEAM_SALE_BY_PLANT = `
  query GetAllTeamSaleRoute(
    $input: TeamSaleInrouteInput
    $skip: Float
    $take: Float
  ) {
    getTeamSaleInRoute(where: $input, skip: $skip, take: $take){
        pageInfo{
              currentPage
              hasNextPage
              hasPreviousPage
              itemsPerPage
              totalItems
              totalPages
          }
      items{
          id
          teamSalesId
          tteamSales{
              id
              name
              subId
          }
      }
    }
  }
`;

export const GET_ALL_ROUTE_BY_TEAM_SALE_IN_PLANT = `
  query GetAllTeamSaleRoute(
    $input: TteamSalesRouteWhereInput
    $skip: Float
    $take: Float
  ) {
    getTeamSalesRoute(where: $input, skip: $skip, take: $take, orderBy:{id: ASC}) {
      pageInfo {
        currentPage
        hasNextPage
        hasPreviousPage
        itemsPerPage
        totalItems
        totalPages
      }
      items {
        id
        routeId
        troute {
          id
          name
          numExpectedDays
        }
        teamSalesId
        plantId
        useYn
        createDate
        modifyDate
      }
    }
  }
`;
